import { Injectable } from '@angular/core';
import { throwError, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, catchError } from 'rxjs/operators';
import { AuthTokenService } from './auth-token.service';
import { ApiService } from './api.service';
import { environment } from '@env/environment';
import { StorageService } from './storage.service';

@Injectable()
export class AuthService {
  public user$ = new BehaviorSubject(null);
  public isAdmin$ = new BehaviorSubject(null);

  isLoggedIn: boolean = false;

  // store the URL so we can redirect after logging in
  redirectUrl: string;

  constructor(
    private httpClient: HttpClient
    , private authToken: AuthTokenService
    , private apiService: ApiService
    , private storage: StorageService
  ) { }

  load(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.storage.get("USER").then(
        user => {
          this.user = user;
          resolve(user);
        },
        error => {
          resolve(null);
        }
      )
    })
  }

  set user(value) {

    this.user$.next(value);
  }
  get user() {
    return this.user$.value;
  }
  set isAdmin(value) {
    this.isAdmin$.next(value);
  }
  get isAdmin() {
    return this.isAdmin$.value;
  }


  login(username: string, password: string): any {
    //console.log("KAMNOUME LOGIN TORA");
    var grant_type = "password";
    var scope = "offline_access";

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };
    let body = new URLSearchParams();
    body.set('grant_type', grant_type);
    body.set('username', username);
    body.set('password', password);
    // body.set('scope', scope); 

    return this.httpClient.post(environment.LOGINURL, body.toString(), httpOptions)
      .pipe(
        map((data: any) => {
          this.isLoggedIn = true;

          this.authToken.token = data.access_token;
          this.loadUser();
          return true;
        },
          catchError(this.handleError))
      );
  }

  loadUser(): void {

    this.apiService.getUser().subscribe((data) => {
      this.user = data;
      this.user.admin = false;
      //this.storage.set("ISADMIN", false);
      if (this.user.roles.some(x => x === "Admin")) {
        this.user.admin = true;
        //this.storage.set("ISADMIN", true);
      }
      this.storage.set("USER", this.user).then(_ => {
        this.IsAdmin();
      });
    })

  }

  public IsAdmin() {
    return new Promise((resolve, reject) => {
      this.storage.get("USER").then(
        user => {
          this.isAdmin = user.admin;
          resolve(this.isAdmin);
        },
        error => {
          reject("Error in Helper.IsAdmin");
        }
      )
    });
  }

  logout(): void {
    this.storage.remove("USER").then(_ => {

      this.authToken.token = null;
      this.isLoggedIn = false;
    }
    );

  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = error.error.error_description
      ? error.error.error_description
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    console.error(errMsg); // log to console instead
    return throwError(errMsg);
    //return Observable.throw(errMsg);
  }
}

export function AuthFactory(service: AuthService): Function {
  return () => service.load();
}